import getConfig from 'next/config'

class Logger {
    private constructor() {}

    public static info = (message: any): void => this.log(() => console.info(message))
    public static warn = (message: any): void => this.log(() => console.warn(message))
    public static error = (message: any): void => this.log(() => console.error(message))

    /** Logs only if in development */
    private static log = (logFunction: Function): void => {
        const { publicRuntimeConfig } = getConfig()
        if (!publicRuntimeConfig.NEXT_PUBLIC_IS_DEVELOPMENT) return
        logFunction()
    }
}

export default Logger
